import { defineComponent, h } from 'vue';
import { QBtn, QDialog } from 'quasar';
import BaseComponent from './BaseComponentMixin.jsx';
import utils from '../../../Shared/utils.jsx';

import { Splitpanes, Pane } from 'splitpanes';
import 'splitpanes/dist/splitpanes.css';

import ControlPicker from './controlPicker.jsx';

export default defineComponent({
    name: 'split-panes-dsgn',
    mixins: [BaseComponent],
    components: {
        QBtn,
        QDialog,
        Splitpanes,
        Pane,
        ControlPicker,
    },
    data: function () {
        return {
            master_key: null,

            //pickervisible: false,
            //picker: null,
            //pickertarget: 'body',
        }
    },
    created() {
        this.master_key = utils.generateUUID();
    },
    //Created Replaced with preRenderComplete
    computed: {
    },
    methods: {
        generateItems(h, controlData, index, parentType) {
            const items = [];
            for (let i = 0; i < controlData.Controls.length; i++) {
                const c = controlData.Controls[i];
                if (!(typeof c === 'object'))
                    continue;

                let DynamicControl = utils.getDesignerComponent(c, null);

                if (!c.$objectId) c.$objectId = utils.generateUUID();

                let id = `${this.master_key}_${c.$objectId}`;
                if (index) id = `${index}_${id}`;

                items.push(
                    <DynamicControl
                        key={id}
                        type={c.ControlType}
                        name={c.ControlData ? c.ControlData.Name : ''}
                        root={this.root}
                        designmodel={c}
                        parentType={parentType}
                        controlData={c.ControlData}
                        controlURL={c.ControlURL}>
                    </DynamicControl>
                );
            }
            return items;
        },

        addPane(e) {
            e.cancelBubble = true;
            e.stopPropagation();

            if (!this.controlData.Panes)
                this.controlData.Panes = [];

            this.controlData.Panes.push({
                DisplayExpression: '',
                Controls: [],
                AllowDoubleClick: true,
            });
        },

        async confirmAddControl(id, title) {
            this.pickervisible = false;

            try {
                const schema_ = await utils.schema.get(id);
                const schema = utils.schema.resolve_Of(schema_)
                const model = utils.schema.createDefaultModel(schema, this.Root);

                const pane = this.controlData.Panes[this.pickertarget];

                if (!pane.Controls)
                    pane.Controls = [];

                pane.Controls.push(model);
                //this.Root.SelectNode(model);
            }
            catch (e) {
                alert(e);
            }
        },

        resizeEvent(e) {
            for (let i = 0; i < e.length && i < this.controlData.Panes.length; i++) {
                this.controlData.Panes[i].InitialSize = parseFloat(e[i].size.toFixed(2));
            }
        },
    },
    render() {
        try {
            const panes = [];

            if (this.selected$ && (!this.controlData.Panes || !this.controlData.Panes.length)) {
                panes.push(
                    <pane>
                        {utils.tt('Add pane',
                            <QBtn size="sm" flat icon="mdi-plus-circle" color="red-9" style={{ zIndex: 992 }} onClick={(e) => this.addPane(e)} />
                        )}
                    </pane>
                );
            }
            else if (this.controlData.Panes)
                for (let i = 0; i < this.controlData.Panes.length; i++) {
                    const p = this.controlData.Panes[i];

                    let btn;
                    if (this.selected$)
                        btn = (
                            utils.tt('Add control to pane',
                                <QBtn size="sm" flat icon="mdi-plus-circle" color="blue-8" style={{ zIndex: 992 }} onClick={(e) => this.addControl(e, i)} />
                            )
                        );

                    let btn2;
                    if (this.selected$ && i === this.controlData.Panes.length - 1)
                        btn2 = (utils.tt('Add pane',
                            <QBtn size="sm" flat icon="mdi-plus-circle" color="red-9" style={{ zIndex: 992 }} onClick={(e) => this.addPane(e)} />)
                        );

                    panes.push(
                        <pane
                            style="display: flex; flex-direction: column;"
                            key={i}
                            size={p.InitialSize}
                            min-size={p.MinSize}
                            max-size={p.MaxSize}
                        >
                            {this.generateItems(h, p, i, "VerticalLayout")}
                            {btn}
                            {btn2}
                        </pane>
                    );
                }

            const style = {
                ...utils.getStyleHints(this.controlData.StyleHints),
                ...utils.getSize(this.controlData.SizeOptions, this.parentType, this.$parent),
                minWidth: "15px",
            };

            return (
                <div
                    style={style}
                    class={{ 'c-SplitPanesDsgn': true, [`c-name-${this.name || 'unnamed'}`]: true, 'designer-container': true, selected: this.selected$ }}
                    onClick={(e) => this.handleClick(e)}
                >
                    <div class={{ "designer-container-hovering": true, 'designer-container-selected-clickthrough': this.selected$ }}></div>
                    <splitpanes
                        class={{ 'default-theme': true }}
                        horizontal={this.controlData.Orientation == 'Horizontal'}
                        push-other-panes={this.controlData.EnablePushAdjacent}
                        first-splitter={this.controlData.ShowFirstSplitter}
                        onResize={(e) => this.resizeEvent(e)}
                    >
                        {panes}
                    </splitpanes>

                    {this.generatePicker(h)}
                </div>
            );
        }
        catch (e) {
            utils.error('SplitPanesDsgn Render failed', e);
            return <div>SplitPanesDsgn Failed to Render {e}</div>;
        }
    }
});